import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Card, CardContent } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { SalesContext } from "context/SalesContext";
import { UserContext } from "context/UserContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RequestDetailContent from "components/RequestDetailContent";

const supportedRoles = [
  "ROLE_MANAGER",
  "ROLE_SALES_RESPONSIBLE",
  "ROLE_RESOURCE",
  "ROLE_LOGISTICS_OFFICER",
  "ROLE_ACCOUNTANT",
  "ROLE_CUSTOMER",
];
const defaultRole = "ROLE_MANAGER";

function DemandDetail() {
  const { user, loading: userLoading } = useContext(UserContext);
  const { getById } = useContext(SalesContext);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const effectiveRole = Array.isArray(user?.roles)
    ? user.roles.find((role) => supportedRoles.includes(role)) || defaultRole
    : defaultRole;

  useEffect(() => {
    async function getData() {
      const result = await getById(id, effectiveRole);
      if (result) setData(result);
      else
        toast.error(`Data for role ${effectiveRole} is empty or undefined`, {
          position: "top-right",
        });
    }
    getData();
  }, [id, effectiveRole]);

  // Kullanıcı yükleniyorsa loading göster
  if (userLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <MDTypography variant="h6" color="text">
            Yükleniyor...
          </MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }

  // Kullanıcı yoksa sign-in'e yönlendir
  if (!user) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <MDTypography variant="h6" color="error">
            Kullanıcı bilgileri yüklenemedi. Lütfen tekrar giriş yapın.
          </MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container justifyContent="flex-start">
          <Grid item xs={12}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Talep Detay
                </MDTypography>
              </MDBox>
              <CardContent>
                {data && (
                  <RequestDetailContent
                    request={data}
                    isCustomer={user?.roles?.includes("ROLE_CUSTOMER")}
                    isResource={user?.roles?.includes("ROLE_RESOURCE")}
                    isLogistics={user?.roles?.includes("ROLE_LOGISTICS_OFFICER")}
                  />
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default DemandDetail;
